<div class="hospital-selection-container">
  <!-- Header Section -->
  <div class="header-section">
    <div class="logo-container">
      <mat-icon class="logo-icon">local_hospital</mat-icon>
      <h1 class="app-title">e-Likita Healthcare Platform</h1>
    </div>
    <p class="subtitle">Select your healthcare facility to continue</p>
  </div>

  <mat-divider class="header-divider"></mat-divider>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="50"></mat-spinner>
    <p class="loading-text">Loading healthcare facilities...</p>
  </div>

  <!-- Hospital Cards Grid -->
  <div *ngIf="!loading && hospitals.length > 0" class="hospitals-grid">
    <mat-card 
      *ngFor="let hospital of hospitals" 
      class="hospital-card"
      [class.selected]="isSelected(hospital)">
      
      <!-- Hospital Header with Icon -->
      <mat-card-header class="hospital-header">
        <div class="hospital-icon-wrapper">
          <mat-icon class="hospital-icon">business</mat-icon>
        </div>
        <div class="hospital-title-section">
          <mat-card-title class="hospital-name">
            {{ hospital.name || 'Unnamed Hospital' }}
          </mat-card-title>
          <mat-card-subtitle class="hospital-type">
            <mat-chip class="type-chip">
              {{ getHospitalType(hospital) }}
            </mat-chip>
          </mat-card-subtitle>
        </div>
      </mat-card-header>

      <mat-divider></mat-divider>

      <mat-card-content class="hospital-content">
        <!-- Description -->
        <div *ngIf="hospital.alias && hospital.alias.length > 0" class="hospital-description">
          <mat-icon class="info-icon">info_outline</mat-icon>
          <p>{{ hospital.alias[0] }}</p>
        </div>

        <!-- Address -->
        <div class="hospital-info-row">
          <mat-icon class="info-icon">place</mat-icon>
          <span class="info-text">{{ getHospitalAddress(hospital) }}</span>
        </div>

        <!-- Phone -->
        <div *ngIf="getHospitalPhone(hospital)" class="hospital-info-row">
          <mat-icon class="info-icon">phone</mat-icon>
          <span class="info-text">{{ getHospitalPhone(hospital) }}</span>
        </div>

        <!-- Email -->
        <div *ngIf="getHospitalEmail(hospital)" class="hospital-info-row">
          <mat-icon class="info-icon">email</mat-icon>
          <span class="info-text">{{ getHospitalEmail(hospital) }}</span>
        </div>

        <!-- Active Status Indicator -->
        <div class="status-indicator" [class.active]="hospital.active !== false">
          <mat-icon class="status-icon">
            {{ hospital.active !== false ? 'check_circle' : 'cancel' }}
          </mat-icon>
          <span class="status-text">
            {{ hospital.active !== false ? 'Active' : 'Inactive' }}
          </span>
        </div>
      </mat-card-content>

      <mat-divider></mat-divider>

      <!-- Action Button -->
      <mat-card-actions class="hospital-actions">
        <button 
          mat-flat-button 
          color="primary"
          class="login-button"
          (click)="onSelectHospital(hospital)"
          [disabled]="isSelected(hospital)">
          <mat-icon>login</mat-icon>
          @if(hospital.id===alreadyLoggedInHospitalId){
            <span>Go to Dashboard</span>
          }@else{
          <span>{{ isSelected(hospital) ? 'Selected' : 'Sign In / Sign Up' }}</span>
          }
        </button>
      </mat-card-actions>
    </mat-card>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && hospitals.length === 0" class="empty-state">
    <mat-icon class="empty-icon">domain_disabled</mat-icon>
    <h2>No Healthcare Facilities Found</h2>
    <p>There are currently no registered healthcare facilities on this platform.</p>
    <button mat-stroked-button (click)="loadHospitals()">
      <mat-icon>refresh</mat-icon>
      Retry
    </button>
  </div>

  <!-- Footer -->
  <div class="footer-section">
    <p class="footer-text">
      © {{ currentYear }} e-Likita Healthcare Platform. All rights reserved.
    </p>
  </div>
</div>
